module.exports = __webpack_public_path__ + "static/media/9DESA25.a319484e.jpg";